import { Components, Theme } from "@mui/material";

export const MuiFormHelperText: Components<Theme>["MuiFormHelperText"] = {
  styleOverrides: {
    root: {
      margin: 0,
      marginTop: 8,
    },
  },
};
